import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';
import  dataurl from '../../assets/config.json';


  

@Injectable()
export class AppraisalService {

    callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');

         
           this.callurl=_global.baseAPIUrl;
         }

            getsysdatetoday()
   {
    return this.http.get(this.callurl + 'getsysdate')
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
 
   }

         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=9)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
            
       return todayDate;
       
         }


         getinstitute(): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getinstitutes_apr/'+this.clcd+'/'+this.aycd)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.inslist;
                  
              }));
        }
         selapprhrtaprd(stuid,stepid,emid): Observable<any> {
            debugger
            let masclid=localStorage.getItem('masclid');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selapprhrtaprd',{clcd:this.clcd,aycd:this.aycd,fmid:stuid,stepid:stepid,emid:emid,masclid:masclid,usid:this.usid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }


          selaprasses(tag): Observable<any> {
            debugger
            let masclid=localStorage.getItem('masclid');
            var emcatid=localStorage.getItem('emcatid');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selaprasses',{clcd:this.clcd,aycd:this.aycd,tag:tag,masclid:masclid,usid:this.usid,emcatid:emcatid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }
           

        selaprasses_set(inid): Observable<any> {
            debugger
            // let masclid=localStorage.getItem('masclid');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
             var emcatid=localStorage.getItem('emcatid');
            return this.http.post(this.callurl + 'selaprasses',{clcd:this.clcd,aycd:this.aycd,tag:'set',masclid:inid,usid:this.usid,emcatid:emcatid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }
         

        
          saveappraisal(admdata: any): Observable<any> {

            debugger
            var emcatid=localStorage.getItem('emcatid');
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.usid=this.usid;
            admdata.emcatid=emcatid;
            return this.http.post(this.callurl + 'saveappraisal', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }

        saveappraisalhedet(admdata: any): Observable<any> {

            debugger
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.usid=this.usid;
            return this.http.post(this.callurl + 'saveappraisalhedet', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }


         selappraisalhedet(qtid,ridh,ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selappraisalhedet',{clcd:this.clcd,aycd:this.aycd,residd:ridd,residh:ridh,aprqtid:qtid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

        selhrtaprstrpln(plnid): Observable<any> {
            debugger
            let masclid=localStorage.getItem('masclid');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selhrtaprstrpln',{clcd:this.clcd,aycd:this.aycd,plnid:plnid,masclid:masclid,emid:this.usid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          savehrstgyplan(admdata: any): Observable<any> {

            debugger
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.usid=this.usid;
            return this.http.post(this.callurl + 'savehrstgyplan', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }

        save_admission_reg(admdata: any): Observable<any> {

            debugger
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.crby=this.usid;
            return this.http.post(this.callurl + 'savestutstudent_reg', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }

        savetcdetails(admdata: any): Observable<any> {

          debugger
          admdata.clcd=this.clcd;
          admdata.aycd=this.aycd;
          admdata.crby=this.usid;
          return this.http.post(this.callurl + 'savetcdetails', admdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

        save_enquiry(admdata: any): Observable<any> {

          debugger
          admdata.clcd=this.clcd;
          admdata.aycd=this.aycd;
          admdata.crby=this.usid;
          console.log(admdata);
          return this.http.post(this.callurl + 'enquiry', admdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

      save_stutenquiry(admdata: any): Observable<any> {

        debugger
        admdata.clcd=this.clcd;
        admdata.aycd=this.aycd;
        admdata.usid=this.usid;
        admdata.crby=this.usid;
        console.log(admdata);
        return this.http.post(this.callurl + 'savestutenquiry', admdata)
            .pipe(map((data: any) => {
                console.log('retres', 'response');
                return data
            }));
    }

    getstutenquiry(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'selstutenquiry/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.enquiry;
              
          }));
    }

    getenquiryinfocnt(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'enquryinfocount/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.enquiryinfocnt;
              
          }));
    }

    uploadmemberphoto(data: File,bkid,dcid): Observable<any> {
      /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
    debugger
      const formData: FormData = new FormData();
      console.log("stuid",bkid)
      formData.append('Image', data, data.name);
        
        formData.append('memid', bkid);
        formData.append('dcid', dcid);
        formData.append('clcd', this.clcd);
        formData.append('aycd', this.aycd);
        formData.append('crby', this.usid);
        console.log("formData",formData);
       return this.http.post(this._global.baseAPIUrl + 'uploadstudentdoc', formData)
       .pipe(map((data: any) => {
           console.log('retres', data);
           return data
       }));
    }


    getstudentdocs(stuid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getstudentdocs/'+this.clcd+'/'+this.aycd+'/'+stuid)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.studoclst;
              
          }));
    }

    delstudentdocs(rid,dcpath): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      var pst={clcd:this.clcd,aycd:this.aycd,rid:rid,dcpath1:dcpath}
      return this.http.post(this.callurl + 'delstudoc',pst)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data;
              
          }));
    }
    getstudent_dbfields(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getstudent_dbfields')
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.arrfields;
              
          }));
    }
    getstudents_clwise(clid,secid,crid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.post(this.callurl + 'selstudent_clwise',{clcd:this.clcd,aycd:this.aycd,clid:clid,scid:secid,crid:crid})
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.stulst;
              
          }));
    }


    getstudentslist(clid,secid,crid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.post(this.callurl + 'selstudents',{clcd:this.clcd,aycd:this.aycd,clid:clid,scid:secid,crid:crid})
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.stulst;
              
          }));
    }

    updatestudentbulk(arrdata,dbfield): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.post(this.callurl + 'updatestudentbulk',{clcd:this.clcd,aycd:this.aycd,usid:this.usid,updfield:dbfield,arrstudent:arrdata})
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data;
              
          }));
    }

    studentoverview(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'studentoverview/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data;
              
          }));
    }

    enqoverview(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'enquiryoverview/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data;
              
          }));
    }


    getcerttypes(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getcerttypes')
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.arrcerftypes;
              
          }));
    }


    getcertformat(clid,crid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getcertformat/'+clid+'/'+crid)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.arrformats;
              
          }));
    }

    getcertformatdet(rid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getcertformatdet/'+rid)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.arrformats;
              
          }));
    }


    stuprofile(oprtype,stuid): Observable<any> {
      debugger
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      
      return this.http.get(this.callurl + 'studentprofile/'+clcd+'/'+aycd+'/'+stuid+'/'+oprtype)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.profdata;
              
          }));
    }

    gethosstudents(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selhosstudent',{clcd:this.clcd,aycd:this.aycd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          getbedsbycat(catid,buid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selbedbycategory',{buid:buid,rmctid:catid,clcd:this.clcd,aycd:this.aycd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          save_allotbed(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'allotbed', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

      getwaleaves(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selwaleaves',{clcd:this.clcd,aycd:this.aycd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          getmenleaves(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selmenleaves',{clcd:this.clcd,aycd:this.aycd,usid:this.usid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          declinleaverequest(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'declinleaverequest', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

        approveleaverequest(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'approveleaverequest', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

         selhrtaprstr_annex1(ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selhrtaprstr_annex1',{clcd:this.clcd,aycd:this.aycd,rid:ridd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

          savehrtaprstr_annex1(obj: any): Observable<any> {
            debugger
            obj.usid=this.usid;
            
            return this.http.post(this.callurl + 'savehrtaprstr_annex1',obj)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

                   selhrtaprstr_annex2(ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selhrtaprstr_annex2',{clcd:this.clcd,aycd:this.aycd,rid:ridd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

          savehrtaprstr_annex2(obj: any): Observable<any> {
            debugger
            obj.usid=this.usid;
            
            return this.http.post(this.callurl + 'savehrtaprstr_annex2',obj)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

                   selhrtaprstr_annex3(ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selhrtaprstr_annex3',{clcd:this.clcd,aycd:this.aycd,rid:ridd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

           savehrtaprstr_annex3(obj: any): Observable<any> {
            debugger
            obj.usid=this.usid;
            
            return this.http.post(this.callurl + 'savehrtaprstr_annex3',obj)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }


           selhrtaprstr_annexa(ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selhrtaprstr_annexa',{clcd:this.clcd,aycd:this.aycd,rid:ridd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

              savehrtaprstr_annexa(obj: any): Observable<any> {
            debugger
            obj.usid=this.usid;
            
            return this.http.post(this.callurl + 'savehrtaprstr_annexa',obj)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }


           selhrtaprstr_annexb(ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selhrtaprstr_annexb',{clcd:this.clcd,aycd:this.aycd,rid:ridd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

              savehrtaprstr_annexb(obj: any): Observable<any> {
            debugger
            obj.usid=this.usid;
            
            return this.http.post(this.callurl + 'savehrtaprstr_annexb',obj)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          selhrtaprstr_annexd(ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selhrtaprstr_annexd',{clcd:this.clcd,aycd:this.aycd,rid:ridd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

              savehrtaprstr_annexd(obj: any): Observable<any> {
            debugger
            obj.usid=this.usid;
            
            return this.http.post(this.callurl + 'savehrtaprstr_annexd',obj)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

           selhrtaprstr_annexe(ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selhrtaprstr_annexe',{clcd:this.clcd,aycd:this.aycd,rid:ridd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

              savehrtaprstr_annexe(obj: any): Observable<any> {
            debugger
            obj.usid=this.usid;
            
            return this.http.post(this.callurl + 'savehrtaprstr_annexe',obj)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }


            selhrtaprstr_annexc(ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selhrtaprstr_annexc',{clcd:this.clcd,aycd:this.aycd,rid:ridd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

              savehrtaprstr_annexc(obj: any): Observable<any> {
            debugger
            obj.usid=this.usid;
            
            return this.http.post(this.callurl + 'savehrtaprstr_annexc',obj)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          delappraisalhedet(admdata: any): Observable<any> {

            debugger
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.usid=this.usid;
            return this.http.post(this.callurl + 'delappraisalhedet', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }


          selhrtaprstr_annexf(ridd): Observable<any> {
            debugger
            
            
            return this.http.post(this.callurl + 'selhrtaprstr_annexf',{clcd:this.clcd,aycd:this.aycd,rid:ridd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrasses;
                    
                }));
          }

              savehrtaprstr_annexf(obj: any): Observable<any> {
            debugger
            obj.usid=this.usid;
            
            return this.http.post(this.callurl + 'savehrtaprstr_annexf',obj)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }
}